// countries denied by PA team or hide by purpose
const denyCountries = [
  // PA unsupported countries
  'AF',
  'BY',
  'BI',
  'CF',
  'CU',
  'CD',
  'ER',
  'GW',
  'IR',
  'IQ',
  'LR',
  'LY',
  'MM',
  'KP',
  'RW',
  'SL',
  'SO',
  'SS',
  'SD',
  'SY',
  'YE',
  'ZW',
  // "United States Minor Outlying Islands" we don't want customers to mess with US
  'UM',
];

export default denyCountries;
